<template>
  <section class="podcasts_archive__content">
    <div class="container">
      <template v-if="latestEpisode">
        <div class="heading">
          <div class="title">
            <h1>{{ latestEpisode.title }}</h1>
            <span v-if="latestEpisode.subtitle">{{ latestEpisode.subtitle }}</span>
          </div>
          <div class="button">
            <router-link :to="{name: 'podcast', params: {id: latestEpisode.id}}">
              <i class="icon-play"></i> Play Latest Episode
            </router-link>
          </div>
        </div>
        <div class="info">
          <div class="row">
            <div class="col" v-if="latestEpisode.links.length > 0">
              <h3>Listen on</h3>
              <div class="links">
                <a v-for="(link, index) in latestEpisode.links"
                   :key="index"
                   :href="link.url"
                   target="_blank"
                   rel="nofollow"
                >
                  <img v-if="link.logo" :src="link.logo.url" :alt="link.logo.alt">
                  <span v-if="link.label">{{ link.label }}</span>
                </a>
              </div>
            </div>
            <div class="col" v-if="latestEpisode.about">
              <h3>About</h3>
              <div v-html="latestEpisode.about"></div>
            </div>
          </div>
        </div>
      </template>
      <div class="episodes">
        <div class="episodes__title">
          <h3>Episodes</h3>
          <div class="dropdown">
            <label for="episodes_season" class="sr-only">Choose Episodes Season</label>
            <select name="episodes_season" id="episodes_season" v-model="selectedSeason">
              <option v-for="season in seasons" :key="season.id" :value="season.id">{{ season.name }}</option>
            </select>
          </div>
        </div>
        <div class="episodes__list">
          <div class="podcast-content__episodes">
            <div class="list" v-if="episodes.length > 0">
              <podcast-item v-for="episode in episodes" :key="episode.id" :episode="episode"/>
            </div>
            <div class="list" v-else>
              <h4>No episodes found for selected season</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PodcastItem from "./PodcastItem";

export default {
  components: {PodcastItem},
  data: () => ({
    selectedSeason: null,
    seasons: [],
    episodes: [],
    latestEpisode: null
  }),
  mounted() {
    this.loadLatestEpisode()
    this.loadSeasons()
  },
  watch: {
    selectedSeason() {
      this.loadEpisodesForSeason()
    }
  },
  methods: {
    loadSeasons() {
      this.$axios.get('/wp-json/podcasts/v1/seasons').then(r => {
        this.seasons = r.data

        if (!this.selectedSeason && r.data.length > 0) {
          this.selectedSeason = r.data[0].id
        }
      })
    },
    loadLatestEpisode() {
      const params = {
        order_dir: 'DESC',
        order_by: 'date',
        per_page: 1
      }
      this.$axios.get('/wp-json/podcasts/v1/podcasts', {
        params
      }).then(r => {
        if (r.data.length > 0) {
          this.latestEpisode = r.data[0]
        }

      })
    },
    loadEpisodesForSeason() {
      const params = {}

      if (this.selectedSeason) {
        params.seasons = [
          this.selectedSeason
        ]
      }
      this.$axios.get('/wp-json/podcasts/v1/podcasts', {
        params
      }).then(r => {
        this.episodes = r.data
      })
    }
  }
}
</script>
